<script setup lang="ts">
import type { Token } from '@/references/tokens';

import TransactionIcon from '@/components/TransactionIcon.vue';
import UiText from '@/components/ui/UiText.vue';
import UiTitle from '@/components/ui/UiTitle.vue';

interface Props {
  src?: string;
  fallbackSrc?: string;
  alt?: string;
  fallbackText?: string;
  fallbackColor?: string;
  loading?: boolean;
  failed?: boolean;
  loaderColor?: string;
  title: string;
  description?: string;
  tokens?: [Token, Token];
}

const props = defineProps<Props>();
</script>

<template>
  <div class="transaction-details-header">
    <TransactionIcon
      class="transaction-details-header__icon"
      :src="props.src"
      :fallback-src="props.fallbackSrc"
      :alt="props.alt"
      :fallback-text="props.fallbackText"
      :fallback-color="props.fallbackColor"
      :loading="props.loading"
      :failed="props.failed"
      :loader-color="props.loaderColor"
      :tokens="props.tokens"
    />
    <div class="transaction-details-header__info">
      <UiTitle :level="2" weight="semibold">{{ props.title }}</UiTitle>
      <UiText v-if="props.description !== undefined" tag="p" size="sm">
        {{ props.description }}
      </UiText>
    </div>
  </div>
</template>

<style scoped>
.transaction-details-header {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0 40px 0 0;
  word-break: break-word;
}

.transaction-details-header__icon {
  flex-shrink: 0;
  margin-right: 16px;
}
</style>
